import http from "../utils/http-common";

const baseTankPath = "api/tank";

export const getYear = () => {
  return http.get(`${baseTankPath}/year`);
};

export const getOptions = (year: number) => {
  return http.get(`${baseTankPath}/setup-tank/options/filter-tank/${year}`);
};

// Setup Tank
export const getSetupTank = (query: string) => {
  return http.get(`${baseTankPath}/setup-tank/?${query}`);
};

export const deleteSetupTankById = (id: string) => {
  return http.delete(`${baseTankPath}/setup-tank/${id}`);
};

export const createSetupTank = (data: any) => {
  return http.post(`${baseTankPath}/setup-tank`, data);
};

export const updateSetupTank = (data: any) => {
  return http.patch(`${baseTankPath}/setup-tank`, data);
};

// Manual Tank 4.0
export const updateManualTank = (id: string, data: any) => {
  return http.patch(`${baseTankPath}/manual-tank/${id}`, data);
};

export const getManualTank = (query: string) => {
  return http.get(`${baseTankPath}/manual-tank/?${query}`);
};

// Report Voc Emission
export const getReportVocEmission = (query: string) => {
  return http.get(`${baseTankPath}/report/voc-emission?${query}`);
};

export const submitReportVoc = (data: any) => {
  return http.post(`${baseTankPath}/report/voc-emission/approve/submit-report`, data);
};

export const getOptionMonthSubmit = (year: number) => {
  return http.get(`${baseTankPath}/report/voc-emission/approve/month/${year}`);
};

export const updateApproveStep = (data: any) => {
  return http.patch(`${baseTankPath}/report/voc-emission/approve/approve-step`, data);
};

export const getInfoStepApprove = (approveId: string) => {
  return http.get(`${baseTankPath}/report/voc-emission/approve/info-step/${approveId}`);
};

export const getOptionVocApprove = () => {
  return http.get(`${baseTankPath}/report/voc-emission/approve/filter-voc-approve`);
};

export const calculateReportVocEmission = (id: string) => {
  return http.post(`${baseTankPath}/report/voc-emission/calculate/${id}`);
};
export const calculateReportVocEmissionMasterChange = (id: string) => {
  return http.post(`${baseTankPath}/report/voc-emission/calculate/change-master/${id}`);
};
